import React, { FC } from 'react';
import { map } from 'ramda';
import { canUseDOM } from 'yafrpl/dom';

import { flushPortals } from './common';

import Container from '../../components/Container';

const ServerPortal: FC = () => {
  return (
    <Container id="portal-container">
      {!canUseDOM() && map(({ children }) => children, flushPortals())}
    </Container>
  );
};

export default ServerPortal;
